import {useSigma} from "@react-sigma/core";
import {useEffect, useState} from "react";

const SigmaReadyController = () => {
  const sigma = useSigma();
  const [ready, setReady] = useState(false);

  useEffect(() => {
    sigma.refresh();  // schedule initial draw
    requestAnimationFrame(() => setTimeout(() => setReady(true), 0)); // IDK really, but it works
    return () => setReady(false);
  }, [sigma]);

  useEffect(() => {
    // No pointer events until ready
    document.getElementById("page-content")?.classList.toggle("pe-none", !ready);
    // sigma.getContainer().setAttribute("data-html2canvas-ignore", "true");
  }, [ready]);

  return null;
}

export default SigmaReadyController;